import { LISTEN_TO_CURRENT_USER_ACCOUNT } from "./accountConstants";

export function listenToCurrentUserAccount(account) {
  return {
    type: LISTEN_TO_CURRENT_USER_ACCOUNT,
    payload: account,
  };
}
